import moment from 'moment-jalaali';

export class TakhfDate {
	static MOMENT_DATE_FORMATS = {
		J_YMD_SLASH: 'jYYYY/jMM/jDD',
		J_YMDHM_SLASH: 'jYYYY/jMM/jDD - HH:mm',
		YMD_SLASH: 'YYYY/MM/DD',
		YMDHM_SLASH: 'YYYY/MM/DD - HH:mm',
		J_YMD_DASH: 'jYYYY-jMM-jDD',
		J_YMDHM_DASH: 'jYYYY-jMM-jDD - HH:mm',
		YMD_DASH: 'YYYY-MM-DD',
		YMDHM_DASH: 'YYYY-MM-DD - HH:mm',
		J_YMMMMD_SPACE: 'jD jMMMM jYYYY',
		J_YYYY: 'jYYYY',
		J_MM: 'jMM',
		J_DD: 'jDD',
	};

	static formatDate = (date, format) => {
		return `${moment(date).format(format)}`;
	};

	static getMonthName = (jMonth) => {
		const month = jMonth.toString();
		switch (true) {
			case month === '1' || month === '01':
				return 'فروردین';
			case month === '2' || month === '02':
				return 'اردیبهشت';
			case month === '3' || month === '03':
				return 'خرداد';
			case month === '4' || month === '04':
				return 'تیر';
			case month === '5' || month === '05':
				return 'مرداد';
			case month === '6' || month === '06':
				return 'شهریور';
			case month === '7' || month === '07':
				return 'مهر';
			case month === '8' || month === '08':
				return 'آبان';
			case month === '9' || month === '09':
				return 'آذر';
			case month === '10':
				return 'دی';
			case month === '11':
				return 'بهمن';
			case month === '12':
				return 'اسفند';
		}
	};
}
